<template>
  <v-card disabled flat>
    <div style="position: relative">
      <h3 style="margin: 15px; text-align: center">
        Store Information
        <v-btn
          icon
          absolute
          v-if="!isEditStoreList"
          @click="editInfo()"
          style="top: -5px; right: 15px"
        >
          <v-icon color="black">edit</v-icon>
        </v-btn>
      </h3>
      <hr style="margin: 0 15px" />
      <editStoreInformation
        :dialog="info_dialog"
        @setDialog="info_dialog = $event"
        @cancelEditInfo="cancelEditInfo()"
        @saveEditInfo="saveEditInfo()"
        :edit_form="edit_form"
        :edit_form_image="edit_form_image"
      />

      <v-card-text>
        <v-tabs-items v-model="tabs.info">
          <v-tab-item
            v-for="(n, i) in lang"
            :key="i"
            transition="fade"
            reverse-transition="fade"
          >
            <div style="padding-top: 1px; background-color: #eeeeee">
              <v-layout row>
                <v-flex>
                  <div class="style-title-detail">
                    Store name :
                    <span class="style-data-detail">{{
                      store_detail.store["store_name_" + n]
                    }}</span>
                  </div>
                  <div class="style-title-detail">
                    Store service :
                    <span class="style-data-detail">{{
                      store_detail.store_service["store_service_name_" + n]
                    }}</span>
                  </div>
                  <div class="style-title-detail">
                    Description :
                    <span class="style-data-detail">{{
                      store_detail.store["store_description_" + n]
                    }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <!-- select type chip -->
        <div>
          <div class="style-title-detail">Store type :</div>
          <v-chip
            v-model="chip1"
            v-for="(n, i) in store_detail.store_type"
            :key="i"
            style="margin-bottom: 15px"
            >{{ n.store_type_name_th }}</v-chip
          >
        </div>
        <!-- END select type chip -->
        <div class="style-title-detail">
          Store status :
          <span class="style-data-detail">{{
            store_detail.store.store_active ? "Active" : "Inactive"
          }}</span>
        </div>
        <div class="style-title-detail">
          Package :
          <span class="style-data-detail">{{
            store_detail.store_package.package_name
          }}</span>
        </div>
        <div class="style-title-detail">
          Price range :
          <span class="style-data-detail"
            >{{ store_detail.store.store_price_range_start }} -
            {{ store_detail.store.store_price_range_end }}</span
          >
        </div>
        <div class="style-title-detail">
          Vat :
          <span class="style-data-detail">{{
            store_detail.store.store_vat
          }}</span>
        </div>
        <div class="style-title-detail">
          Store service charge :
          <span class="style-data-detail">{{
            store_detail.store.store_service_charge
          }}</span>
        </div>
        <div class="style-title-detail">
          Weserve service charge :
          <span class="style-data-detail"></span>
        </div>
        <div class="style-title-detail">
          Tel :
          <span class="style-data-detail"> +66 {{ groupStoreTel }} </span>
        </div>
        <div class="style-title-detail">
          Email :
          <span class="style-data-detail">{{
            store_detail.store.store_email
          }}</span>
        </div>
        <div class="style-title-detail">
          Logo image :
          <span class="style-data-detail">{{
            showImageName(store_detail.store.store_image)
          }}</span>
        </div>
        <a
          :href="store_detail.store.store_image"
          target="_blank"
          style="text-decoration: none"
        >
          <v-btn depressed small color="#e0e0e0">
            <v-icon small>image</v-icon>Preview
          </v-btn>
        </a>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import editStoreInformation from "../EditStore/EditStoreInformation";
import { mapGetters } from "vuex";
export default {
  props: ["tabs", "store_detail"],
  components: {
    editStoreInformation,
  },
  data() {
    return {
      edit_form_image: {
        logo_name: "",
        banner_name: "",
      },
      edit_form: null,
      chip1: "",
      info_dialog: false,
      lang: ["th", "en", "cn"],
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
    groupStoreTel() {
      let store_tel_name_temp = "";
      if (this.store_detail.store.store_tel.constructor === Array) {
        for (let val of this.store_detail.store.store_tel) {
          let index = this.store_detail.store.store_tel.indexOf(val);
          if (index <= this.store_detail.store.store_tel.length - 1) {
            store_tel_name_temp = store_tel_name_temp + val.tel;
          }
          if (index < this.store_detail.store.store_tel.length - 1) {
            store_tel_name_temp = store_tel_name_temp + ",";
          }
        }
      }
      this.store_detail.store.store_tel_name_temp = store_tel_name_temp;
      return store_tel_name_temp;
    },
  },
  methods: {
    showImageName(url) {
      let name_image = null;
      if (url != null) {
        let name = url.split("/");
        name_image = name[name.length - 1];
      }
      return name_image;
    },
    setEditForm() {
      this.edit_form = {
        store_id: null,
        store_code: null,
        store_name_th: "",
        store_description_th: "",
        store_name_en: "",
        store_description_en: "",
        store_name_cn: "",
        store_description_cn: "",
        store_country_tel: "+66",
        store_tel: [{ tel: "" }],
        store_email: [{ email: "" }],
        store_vat: null,
        store_price_range_start: null,
        store_price_range_end: null,
        store_package_id: null,
        store_active: false,
        store_store_service_id: null,
        store_type_old: [],
        store_type_new: [],
        store_service_charge: null,
        store_use_pos: null,
        store_user_name: null,
      };
    },
    saveEditInfo() {
      this.setEditForm();
    },
    cancelEditInfo() {
      this.setEditForm();
    },
    editInfo() {
      this.info_dialog = true;
      this.edit_form.store_use_pos = this.store_detail.store.store_use_pos;
      this.edit_form.store_user_name = this.store_detail.store.store_user_name;
      this.edit_form.store_service_charge = this.store_detail.store.store_service_charge;
      this.edit_form.store_name_cn = this.store_detail.store.store_name_cn;
      this.edit_form.store_name_th = this.store_detail.store.store_name_th;
      this.edit_form.store_name_en = this.store_detail.store.store_name_en;
      this.edit_form.store_id = this.store_detail.store.store_id;
      this.edit_form.store_code = this.store_detail.store.store_code;
      this.edit_form.store_description_th = this.store_detail.store.store_description_th;
      this.edit_form.store_description_en = this.store_detail.store.store_description_en;
      this.edit_form.store_description_cn = this.store_detail.store.store_description_cn;
      this.edit_form.store_country_tel = this.store_detail.store.store_country_tel;
      if (
        this.store_detail.store.store_tel.constructor === Array &&
        this.store_detail.store.store_tel.length > 0
      ) {
        this.edit_form.store_tel = JSON.parse(
          JSON.stringify(this.store_detail.store.store_tel)
        );
      } else {
        this.edit_form.store_tel = [{ tel: "" }];
      }
      try {
        let store_email_split = this.store_detail.store.store_email.split(",");
        this.edit_form.store_email = [];
        for (let val of store_email_split) {
          this.edit_form.store_email.push({ email: val });
        }
      } catch {
        this.edit_form.store_email = [{ email: "" }];
      }

      this.edit_form.store_vat = this.store_detail.store.store_vat;
      this.edit_form.store_price_range_start = this.store_detail.store.store_price_range_start;
      this.edit_form.store_price_range_end = this.store_detail.store.store_price_range_end;
      this.edit_form.store_package_id = this.store_detail.store_package.package_id;
      this.edit_form.store_active = this.store_detail.store.store_active;
      this.edit_form.store_store_service_id = this.store_detail.store_service.store_service_id;
      this.edit_form.store_type_old = [];
      this.edit_form.store_type_new = [];
      for (let n in this.store_detail.store_type) {
        this.edit_form.store_type_old.push(
          this.store_detail.store_type[n].store_type_id
        );
        this.edit_form.store_type_new.push(
          this.store_detail.store_type[n].store_type_id
        );
      }
      if (this.store_detail.store.store_image != null) {
        let name = this.store_detail.store.store_image.split("/");
        this.edit_form_image.logo_name = name[name.length - 1];
      }
    },
  },
  created() {
    this.setEditForm();
  },
};
</script>

<style scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}
</style>
